module.exports = __webpack_public_path__ + "img/wondernorse_tech_Normal_ua.51e97bb8.webp";